export default "__VITE_ASSET__aM3_Anu6__"